import styled from 'styled-components'
import { Button } from '@shipt/design-system-buttons'
import { screenSizes } from '@shipt/design-system-themes'

interface Props {
  isActive?: boolean
  onClick?: () => void
  className?: string
  children: React.ReactNode
}
export const FilterPill = ({ isActive, onClick, children, className }: Props) => (
  <FilterPillButton
    variant={isActive ? 'secondary' : 'tertiary'}
    size="sm"
    onClick={onClick}
    isActive={isActive}
    className={className}
  >
    {children}
  </FilterPillButton>
)

interface PillButtonProps {
  isActive?: boolean
}

const FilterPillButton = styled(Button)<PillButtonProps>`
  height: 1.75rem;
  white-space: nowrap;
  margin-right: 0.5rem;
  padding: 0 16px;
  align-items: center;
  justify-content: center;

  @media ${screenSizes.tablet} {
    height: 2.25rem;
    margin: 0.5rem 0.5rem 0.5rem 0;
  }

  .buttonContent {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
  }
`
